module.exports = __webpack_public_path__ + "img/eggsalad_eggs_cut.23a4fe12.jpg";